import { ReactNode } from 'react';
import { Box } from '@mui/material';

export const BorderBox = ({ children }: { children: ReactNode }) => {
  return (
    <Box
      sx={{
        p: { xs: 4, sm: 6 },
        borderRadius: { xs: 2, sm: 3 },
        boxShadow: 'none',
        bgcolor: 'white',
        border: '2px solid',
        borderColor: 'borderColors.primary',
      }}
    >
      {children}
    </Box>
  );
};
